import ContentManager from './base';
import Remote from '../remote';
import Utils from '../utils';
import flash from '../flash';
import Panel from '../panels';
import Comments from '../../comments/comments';

export default class LegendContentViewer extends ContentManager {
  constructor(context, remote, options) {
    super(context, remote, options);
    this.remote = new Remote('/learn/behaviors');
  }

  loadModal() {
    this.panel = new Panel(Panel.NODE, '', {
      fullscreen: this.options.fullscreen,
    });
    Utils.promiseWithFuse(
      () => {
        this.panel.updateContent('<div class="lp--panelLoader"></div>');
      },
      this.load().then((data) => {
        this.panel.updateContent(data);
        this.attach();

        this.panel.eventSource.on('willHide.panel', () => {
          this.detach();
        });

        return this.setupModal(this.panel);
      }),
      400,
    );

    return Promise.resolve(this.panel);
  }

  attach() {
    super.attach();
    this.panel.content.find('.lp--js-nodeComment').on('keypress ' + Utils.tapInteractionEvent + '.comments', (ev) => {
      $(document).trigger(Comments.EventTriggerName, {
        entity_uuid: this.context.getId(),
        entity_type: 'node',
      });
    });
  }

  detach() {
    this.panel.content.find('.lp--js-nodeComment').off('.comments');
  }

  parseResult(content) {
    return $(
      Handlebars.templates['behaviors/legend/viewer_single'](
        $.extend(
          {
            navigation: this.options.navigation,
            node: {
              name: this.context.getName(),
              image: this.context.getImage(),
            },
          },
          content,
        ),
      ),
    );
  }

  setupModal(panel) {
    super.setupModal(panel);
    return panel;
  }

  load() {
    return this.remote
      .get(this.options.getURLFor(ContentManager.Content.Legend, this.context, this.options), { type: 'json' })
      .on('noAccess', () => {
        // Redirect to an url we want to return to after the login
        window.location.replace('/me');
      })
      .then((result) => {
        try {
          this.immersiveReader.buildFromContent(result, 'legend');
        } catch (error) {
          console.error(error);
        }
        return this.parseResult(result);
      })
      .catch((err) => {
        flash(i18n.__('error_behavior_load_failed'));
      });
  }
}
